import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(url: string | undefined): SafeResourceUrl {
    let transformedUrl = url || '';

    // Convert YouTube shortened URLs to embed URLs
    // Example URL: https://youtu.be/crPABDEUJWU?si=Vfj4BiZvheMraoDB
    const shortUrlMatch = transformedUrl.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (shortUrlMatch && shortUrlMatch[1]) {
      transformedUrl = `https://www.youtube.com/embed/${shortUrlMatch[1]}`;
    } else {
      // Optionally, also handle standard youtube watch URLs
      // Example URL: https://www.youtube.com/watch?v=crPABDEUJWU
      const watchUrlMatch = transformedUrl.match(/v=([a-zA-Z0-9_-]+)/);
      if (watchUrlMatch && watchUrlMatch[1]) {
        transformedUrl = `https://www.youtube.com/embed/${watchUrlMatch[1]}`;
      }
    }

    return this.sanitizer.bypassSecurityTrustResourceUrl(transformedUrl);
  }
}
